// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomCard_button__19CHw","buttonSecondary":"CustomCard_buttonSecondary__1cqb-","buttons":"CustomCard_buttons__1qVok"};